/**
 * Configuração Central do R-Max
 * Gerencia Feature Flags (ex: Chave da Google Play) e Parâmetros Comerciais dos Planos.
 */

import { APP_DOMAINS, APP_PRICING } from '@r-max/shared';

export const APP_CONFIG = {
  // Chave Liga/Desliga para exibição de Badges/Links da Google Play Store
  // Altere no .env (VITE_ENABLE_GOOGLE_PLAY=true) ou altere o valor padrão para true no dia 1º de Setembro.
  ENABLE_GOOGLE_PLAY_STORE: import.meta.env.VITE_ENABLE_GOOGLE_PLAY === 'true' || false,

  // Link Oficial na Google Play Store
  GOOGLE_PLAY_URL: import.meta.env.VITE_GOOGLE_PLAY_URL || 'https://play.google.com/store/apps/details?id=br.com.resolvmax.rmax',

  // Identificador do Pacote Android (TWA)
  ANDROID_PACKAGE_ID: 'br.com.resolvmax.rmax',

  // Domínios Oficiais Autorizados
  DOMAINS: {
    APP_WEB: APP_DOMAINS.APP_WEB,
    HUB_WEB: APP_DOMAINS.HUB_WEB,
  },

  // Estrutura Financeira Oficial dos Planos
  PRICING: APP_PRICING,
} as const;

